export default __webpack_public_path__ + "73b7fb77836d2829e1976b19144d76f1.svg";